import { z } from 'zod';

export const queryBooleanSchema = z.preprocess((value) => {
  if (typeof value === 'boolean') {
    return value;
  }

  if (typeof value === 'number') {
    if (value === 1) {
      return true;
    }

    if (value === 0) {
      return false;
    }
  }

  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    if (normalized === 'true' || normalized === '1') {
      return true;
    }

    if (normalized === 'false' || normalized === '0') {
      return false;
    }
  }

  return value;
}, z.boolean());

//Copied from https://github.com/colinhacks/zod/discussions/672#discussioncomment-5851662
export const makeFilteredArraySchema = <T extends z.ZodType>(schema: T) =>
  z
    .array(z.unknown()) // `z.unknown()` more relevant than `z.any()` and avoid linting issue with any
    .transform((items) =>
      items.filter(
        (item): item is z.infer<T> => schema.safeParse(item).success
        // `item is z.infer<T>` prevents the output type to be `unknown`. Ok to cast the type as it's been validated
      )
    );